module.exports = {
  footerText: 'Copyright Aseman Sole © 2023',
}
